export const PartnerOffers = {
    IMG_PATH: '/i/pages/partner-offers/',
}
